export default "__VITE_ASSET__ksnS1iUy__"